module.exports = __webpack_public_path__ + "static/media/gitLogo.76d344f0.svg";